module.exports = __webpack_public_path__ + "img/dano-store.92ce6d43.jpg";